import { IRootState } from '../reducer'
import { prefix } from './actions'

export const projects = (state: IRootState) => state[prefix].projects
export const favoriteProjects = (state: IRootState) => state[prefix].favoriteProjects
export const selectedProject = (state: IRootState) => state[prefix].selectedProject
export const projectTasks = (state: IRootState) => state[prefix].projectTasks
export const projectCalendarTasks = (state: IRootState) => state[prefix].projectCalendarTasks
export const projectUndatedTasks = (state: IRootState) => state[prefix].projectUndatedTasks
export const projectStatusSummary = (state: IRootState) => state[prefix].projectStatusSummary
export const liveProjectChange = (state: IRootState) => state[prefix].liveProjectChange
